import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Card } from "primereact/card";

const SecurityForm = ({
  accessForm,
  isSavingAccess,
  onUpdateField,
  onSave,
}) => (
  <Card title="Cambiar mi clave">
    <div className="flex flex-column gap-3">
      <div className="flex align-items-center gap-3">
        <label className="w-3 admin-text-base">Usuario:</label>
        <InputText value={accessForm.usuario} onChange={(e) => onUpdateField("usuario", e.target.value)} className="flex-1" />
      </div>
      <div className="flex align-items-center gap-3">
        <label className="w-3 admin-text-base">Contraseña actual:</label>
        <Password value={accessForm.contrasenaActual} onChange={(e) => onUpdateField("contrasenaActual", e.target.value)} toggleMask feedback={false} className="flex-1" autoComplete="off" />
      </div>
      <div className="flex align-items-center gap-3">
        <label className="w-3 admin-text-base">Nueva contraseña:</label>
        <Password value={accessForm.contrasena} onChange={(e) => onUpdateField("contrasena", e.target.value)} toggleMask weakLabel="Débil" mediumLabel="Media" strongLabel="Segura" disabled={!accessForm.contrasenaActual.trim()} className="flex-1" />
      </div>
      <div className="flex align-items-center gap-3">
        <label className="w-3 admin-text-base">Confirmación:</label>
        <Password value={accessForm.confirmarContrasena} onChange={(e) => onUpdateField("confirmarContrasena", e.target.value)} toggleMask feedback={false} disabled={!accessForm.contrasenaActual.trim()} className="flex-1" />
      </div>
    </div>
    <div className="flex gap-2 mt-3">
      <Button label={isSavingAccess ? "Guardando..." : "Guardar"} icon="pi pi-save" severity="success" size="small" onClick={onSave} disabled={isSavingAccess} />
    </div>
  </Card>
);

export default SecurityForm;
